<template>
    <v-container>
      <v-card class="mx-auto" flat>
        <v-row >
          <v-col>
            <p class="headline font-weight-bold text-center" style="color:#AF8936; font-size: 27px !important;">
              Estadísticas de Principio de Interés Superior
            </p>
          </v-col>
        </v-row>

        <v-card
          class="mx-auto"
          max-width=""
          tile
        >
          <v-list dense>
            <!-- <v-list-item-group> -->
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style=" font-size: 18px !important;" v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            <!-- </v-list-item-group> -->
          </v-list>
        </v-card><br><br>

        <v-row>
          <v-col cols="12">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="showReporte" dark color="#616161" @click="reportePdf()" class="white--text mt-n9">
                <v-icon>mdi-file-pdf</v-icon>ver reporte
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>

        <v-divider class="mb-9"></v-divider>
        <v-row v-if="showReporte" justify="center">
          <v-col cols="12" sm="6">
            <v-data-table
              :headers="headers"
              :items="listEstadisticas"
              :items-per-page="5"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              no-data-text="No se Encontraron Resultados"
            >
            <template v-slot:item.total= "{item}">
              <div class="text-right">{{ item.total }}</div>
            </template>
            <template slot="body.append">
            <tr class="brown--text">
              <th><div class="title">Totales</div></th>
              <th><div class="text-right title">{{ sumField('total')}}</div></th>
            </tr>
            </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" sm="6">
            <column-chart
              :data="listTocasTotal"
              :colors="colors"
              label="Total"
              :library="{animation: {duration: 1000}}" :messages="{empty: 'No se Encontraron Resultados.'}"
              xtitle="Salas" ytitle="Sentencias"
              >
            </column-chart>
          </v-col>

        </v-row>
        <v-dialog
          v-model="progressLoading"
          persistent
          width="300"
        >
          <v-card
            color="#AF8936"
            dark
          >
            <v-card-text>
              <b>DESCARGANDO REPORTE...</b>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

      </v-card>

</v-container>

</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        materia_id: '',
        delito: '',
        accion_especifica_id: '',
        listDelitosAcciones:[],
        listAccionesEspecificas:[],
        listAccionesSimultaneas:[],
        listMateriasSearch:[],
        listTotales:[],
        // listEstadisticas:[],
        listTocasTotal:[],
        listSalasTotal:[],
        colors:[['#AF8936', '#607D8B', '#1d2e4c', '#0b6e00', '#006ca2', '#ff3333', '#d60001']],
        progressLoading: false,
        searchMateria: true,
        searchInput:'',
        validateDelito: true,
        showReporte: false,
        loading:false,
        principio_interes: true,
        items: [
          { text: '•	Materia: FAMILIAR', icon: 'mdi-minus' },
          { text: '•	Acción: ALIMENTOS', icon: 'mdi-minus' },
          { text: '•	Acción Específica: MENORES', icon: 'mdi-minus' },
        ],
        headers: [
          {
            text: 'Sala',
            align: 'start',
            sortable: false,
            value: 'salas_data.nombre',
            class: "grey-text title"
          },
          { text: 'Total de Tocas', value: 'total',class: "grey-text title", sortable: false, },
        ],
      }
    },
    computed:{
      ...mapGetters([
        "listEstadisticas"
      ])
    },
    watch: {
      delito (val){
        this.validateDelito = false;
        this.showReporte = false
        if(!val){
          this.validateDelito = true;
          this.accion_especifica_id = ''
          this.showReporte = false
        }
      },
      materia_id (val){
        this.searchMateria = false;
        this.getDelitos();
        if(!val){
          this.delito = '',
          this.searchMateria = true;
        }
      },
      accion_especifica_id (val){
        this.showReporte = false
        if(!val){
          this.showReporte = false
        }
      },
      searchInput: function (value) {
        if(value){
          if (value.length > 3) {
            this.getDelitosFilter(value)
          }
        }
        if (!value) {
          this.getDelitos()
        }
      },
    },
    mounted(){
      this.getMaterias()
      this.materia_id = 3
      this.delito = 'ALIMENTOS'
      this.getAcciones()
      this.accion_especifica_id = 171
      this.getInteresSuperior()
    },
    methods:{
      clear(){
        this.delito = ''
        this.accion_especifica_id = ''
        this.showReporte = false
      },
      sumField(key) {
        // sum data in give key (property)
        return this.listEstadisticas.reduce((a, b) => a + (b[key] || 0), 0)
      },
      validate(){
        this.listTocasTotal = []
        this.loading = true
        this.getInteresSuperior()
      },
      getInteresSuperior() {
        // this.colors = []
        var delito_id = ''
        if (this.delito) {
          delito_id = this.delito.id
        }
        if (this.principio_interes == true) {
          delito_id = 1082
        }
        // this.listEstadisticas = []
        this.$store.dispatch("GET_ESTADISTICAS",  { url: "/tocas/estadisticas",
          data: {
            materia_id: this.materia_id,
            delito_id: delito_id,
            accion_especifica_id: this.accion_especifica_id
          }
        })
        .then(response => {
          // console.log(response.data.data);
          // this.listEstadisticas = response.data.data.tocas
          this.loading = false
          this.showReporte = true
          this.principio_interes = false
          this.listEstadisticas.forEach((item, i) => {
            this.listSalasTotal.push('sala '+item.sala_id)
            this.listSalasTotal.push(item.total)
            this.listTocasTotal.push(this.listSalasTotal)
            this.listSalasTotal = []
          });
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMaterias() {
        this.loading = true;
        this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => {
          this.listMateriasSearch = response.data.data.materias;
          // console.log(response.data.data.materias);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getDelitos() {
        this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
          data: {
            materia_id:this.materia_id,
          }
          }).then(response => {
          this.listDelitosAcciones = response.data.data.delitos;
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getDelitosFilter(value) {
        this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
          data: {
            materia_id:this.materia_id,
            nombre_delito: value
          }
          }).then(response => {
          this.listDelitosAcciones = response.data.data.delitos;
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getAcciones(){
        if (this.delito) {
          this.getEspecificas()
          this.getSimultaneas()
        }
      },
      getEspecificas() {
        var delito_id = ''
        if (this.principio_interes == true) {
          delito_id = 1082
        }else {
          delito_id = this.delito.id
        }
        this.$store.dispatch("GET_ACCIONES_ESPECIFICAS",  { url: "/delito/"+delito_id+"/acciones-especificas",
          }).then(response => {
            // console.log(response.data.data.acciones_especificas);
          this.listAccionesEspecificas = response.data.data.acciones_especificas;
          // this.principio_interes = false
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSimultaneas() {
        this.$store.dispatch("GET_ACCIONES_SIMULTANEAS",  { url: "/delito/"+this.delito.id+"/acciones-simultaneas",
          }).then(response => {
            // console.log(response.data.data.acciones_simultaneas);
          this.listAccionesSimultaneas = response.data.data.acciones_simultaneas;
        })
        .catch(error => {
          console.log(error);
        });
      },
      reportePdf(){
        var delito_id = ''
        if (this.delito) {
          delito_id = this.delito.id
        }
        if (this.principio_interes == true) {
          delito_id = 1082
        }
        this.progressLoading = true
        this.$store.dispatch("GET_PDF", { url:"/tocas/reporteTocas",
          data: {
            materia_id: this.materia_id,
            delito_id: delito_id,
            accion_especifica_id: this.accion_especifica_id,
          }
        }).then((response) => {
          this.progressLoading = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          let inicio = this.fecha_inicio
          let fin = this.fecha_fin
          link.setAttribute('download', 'Reporte.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.progressLoading = false
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      }
    }

  }
</script>
